<template>
  <section class="content">
    <div class="row">
      <div class="col-xs-12" v-if="!loading">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">{{ 'sp_auth_redirect' | translate }}</h3>
          </div>
          <div class="box-body">
            <div :class="responseType==='danger'?'alert alert-danger':'alert alert-success'">
              <p class="message"><span>{{response}}</span></p>
            </div>
            <a href="/directsale/amazon" class="btn btn-info">{{ 'back_to_directsales_amazon' | translate }}</a>
          </div>
        </div>
      </div>
      <div class="overlay" v-show="loading">
        <img class="loading-gif" src="/static/img/blabla.svg"/>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SPAuthView',
  data () {
    return {
      responseType: '',
      loading: false,
      response: ''
    }
  },
  methods: {
    getToken () {
      this.loading = true
      let urlSearchParams = new URLSearchParams(window.location.search)
      let params = Object.fromEntries(urlSearchParams.entries())

      if (!params.spapi_oauth_code || !params.selling_partner_id) {
        this.responseType = 'danger'
        this.response = 'Fehler! Fehlende Daten'
        this.loading = false
      } else {
        API.put('/accounting/company/saveSPAuth', {
          'state': params.state,
          'oauth_code': params.spapi_oauth_code,
          'selling_partner_id': params.selling_partner_id
        }).then(response => {
          this.responseType = 'success'
          this.response = 'Authentifizierung erfolgreich!'
          this.loading = false
        }).catch(error => {
          this.responseType = 'danger'
          this.response = error.response.data.message
          this.loading = false
        })
      }
    }
  },
  mounted () {
    this.getToken()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Accounting/SPAuthView.vue